module.exports = __webpack_public_path__ + "static/media/learning.147544e7.jpg";